import { z } from 'zod';

import { nullishDefault } from '../../../utils/nullableDefault';

export const BeschaeftigungArbeitsloser = z.object({
    sonstigesEinkommenMonatlich: nullishDefault(z.number()),
});

// arbeitsloser: yup
// .object()
// .shape({
// 	sonstigesEinkommenMonatlich: yup.number().optional().nullable().default(null),
// })
// .notRequired()
// .default(undefined)
// .when('beschaeftigungsart', {
// 	is: 'ARBEITSLOSER',
// 	otherwise: (s) => s.strip(),
// 	then: (s) => s.optional().nullable().default(null),
// }),
